import React, { useRef, useEffect, useCallback } from "react";
import { Container } from "reactstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import BenefitsSectionPlanPage1 from "./BenefitsSectionPlanPage1";
import BenefitsSectionPlanPage2 from "./BenefitsSectionPlanPage2";
import TermLife from "../TermLife/TermLife";
import CriticalIllness from "../CriticalIllness/CriticalIllness";
import "../../Components/test.css";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export const BenefitSectionPlanPage = ({ handleFooter, callBackSection }) => {
  const timelines = useRef([]);
  const currentSection = useRef(0); // Track the current active section
  const sectionsRef = useRef([]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
  };

  return (
    <div className="scroll-section vertical-section section">
      <div className="">
        <div className="desktop-slider">
          <Slider {...settings} className="vs-slider relative  w-[100%] ">
            <BenefitsSectionPlanPage1 key="universal" />
            <BenefitsSectionPlanPage2 key="term" />
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BenefitSectionPlanPage;
